import Vue from 'vue';
import {request, setAuthInHeader} from "@/api/request";
// import {req} from "vuelidate/src/validators/common";


Vue.prototype.$api = {
    $auth: { // 계정 로그인 / 회원가입 api
    },
    $board: {
        getMainNews(params) {
            return request.get(`board/news/notice`, params).then(({data}) => data);
        },
        getMainDonate(params) {
            return request.get(`board/donate/notice`, params).then(({data}) => data);
        },
        getBusiness(params) {
            return request.get(`board/business`, params).then(({data}) => data);
        },
        getFinancial(params) {
            return request.get(`board/financial`, params).then(({data}) => data);
        },
        getAlbum(params) {
            return request.get(`board/album`, params).then(({data}) => data);
        },
        getNews(params) {
            return request.get(`board/news`, params).then(({data}) => data);
        },
        getDonate(params) {
            return request.get(`board/donate`, params).then(({data}) => data);
        },
        getDonatePrime(params) {
            return request.get(`board/donate/important`, params).then(({data}) => data);
        }
    },
    $member: {
        getMember(params) {
            return request.get(`mentor`, params).then(({data}) => data);
        },
        applyMember(params) {
            return request.post(`mentor/apply`, params).then(({data}) => data);
        }
    },
    $area: {
        getArea(params) {
            return request.get(`area`, params).then(({data}) => data);
        },
    },
    $file: {
        getFile(params) {
            return request.get(`file`, params).then(({data}) => data);
        },
        createFile(params) {
            return request.post(`file`, params).then(({data}) => data);
        },
        updateFile(params) {
            return request.post(`file`, params).then(({data}) => data);
        },
    },
    $config: {
        getConfig(params) {
            return request.get(`config`, params).then(({data}) => data);
        }
    },
    $popup: {
        getPopup(params) {
            return request.get(`popup`, params).then(({data}) => data);
        }
    },
    $banner: {
        getBanner(params) {
            return request.get(`banner`, params).then(({data}) => data);
        }
    },
    $icon: {
        getWebIcon(params) {
            return request.get(`icon`, params).then(({data}) => data);
        }
    },
    $history: {
        getHistory(params) {
            return request.get(`history`, params).then(({data}) => data);
        }
    },
    $handler: {
        authHeader: setAuthInHeader
    }
};

export default Vue.prototype.$api;
